module.exports = __webpack_public_path__ + "img/Magneperit_Gray_1280x1010.6146cdd8.jpg";